var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "card",
    { staticClass: "card-stats" },
    [
      _c("b-row", [
        _vm.$slots.header
          ? _c("div", { staticClass: "col-5" }, [
              _c(
                "div",
                { staticClass: "icon-big text-center" },
                [_vm._t("header")],
                2
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "col-7" }, [
          _c(
            "div",
            { staticClass: "numbers" },
            [
              _vm._t("content", [
                _vm.subTitle
                  ? _c("p", { staticClass: "card-category" }, [
                      _vm._v(_vm._s(_vm.subTitle))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("h4", { staticClass: "card-title" }, [
                  _vm._v(_vm._s(_vm.title))
                ])
              ])
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _vm.$slots.footer
        ? _c(
            "div",
            { staticClass: "stats", attrs: { slot: "footer" }, slot: "footer" },
            [_vm._t("footer")],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63d1c903", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63d1c903","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cards/StatsCard.vue
// module id = gSOh
// module chunks = 4